import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionAssessmentUpdateInput } from '../generated/globalTypes';
import { updateSubscriptionAssessmentMutation, updateSubscriptionAssessmentMutationVariables } from '../generated/updateSubscriptionAssessmentMutation';
import { subscriptionAssessmentFieldsFragment } from '../models/SubscriptionAssessment';

/**
 * Get a callback to update a SubscriptionAssessment in the store.
 */
export function useUpdateSubscriptionAssessmentCallback(): [(id: string, model: SubscriptionAssessmentUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSubscriptionAssessmentMutation, updateSubscriptionAssessmentMutationVariables>(
        gql`
            mutation updateSubscriptionAssessmentMutation ($model: SubscriptionAssessmentUpdateInput!) {
                updateSubscriptionAssessment(model: $model) {
                    ...subscriptionAssessmentFields
                }
            }

            ${subscriptionAssessmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SubscriptionAssessmentUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
